import React from 'react'
import PropTypes from 'prop-types'
import PerformanceItem from '../PerformanceItem'

function DarkDaysModal() {
	return (
		<div className='performance_item_modal dark_days_modal'>
			<h3>Dark Days</h3>
			<p>
				Rather than doing bursts of advertising, top performing advertisers run ads consistently across the duration of campaigns. This correlates to optimal campaign performance.
			</p>
		</div>
	)
}

const renderDarkDaysModal = (value, benchmark) => {
	if(value===null) {
		return (
			<p>Unfortunately we were not able to calculate your dark days.</p>
		)
	}
	if(value <= benchmark.us) {
		return (
			<p>Great! You have no days without ad spend in the past 30 days.</p>
		)
		//Great
	} else {
		// Bad
		return (
			<p>You have {value} days without ad spend. Keep a consistent spend to maximize results.</p>
		)
	}
}

function DarkDaysPerformanceItem(props) {
	const { score, maxScore, value, benchmark } = props.apiScore
	
	// {"cpc":{"score":0,"maxScore":18,"value":null,"benchmark":{"us":1.1,"global":0.54}}
	return (
		<PerformanceItem
			title="Dark Days"
			score={score}
			maxScore={maxScore}
			showPerformanceModal={() => { props.showPerformanceModal('darkDays') }}>
			{renderDarkDaysModal(value, benchmark)}
		</PerformanceItem>
	)
}

DarkDaysPerformanceItem.propTypes = {
	apiScore: PropTypes.object,
	showPerformanceModal: PropTypes.func
}

export { DarkDaysModal, DarkDaysPerformanceItem }


// WEBPACK FOOTER //
// ./src/containers/ReportLoaderTopLeads/components/performance_items/DarkDays.js